export function getFlagsSubset(flags, flagIdentifiers) {
    const flagDefaultMap = Array.isArray(flagIdentifiers)
        ? flagIdentifiers.reduce((map, flagIdentifier) => ({
            ...map,
            [flagIdentifier]: undefined
        }), {})
        : flagIdentifiers;
    return {
        ...flagDefaultMap,
        ...Object.fromEntries(Object.entries(flags).filter(([flagIdentifier]) => flagIdentifier in flagDefaultMap))
    };
}
